module.exports = "/_next/static/images/steps-sticker-6c5cf01b862526959d262efaf25dc314.png";